import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { TranslateModule } from '@ngx-translate/core';
import { SupplierSelectorComponent } from './supplier-selector/supplier-selector';
import { SuppliersListComponent } from './suppliers-list/suppliers-list';
import { SupplierListModalComponent } from './supplier-list-modal/supplier-list-modal';
import { OrderBy } from './order-by.pipe';

@NgModule({
  declarations: [
    SupplierListModalComponent,
    SupplierSelectorComponent,
    SuppliersListComponent,
    OrderBy
  ],
  imports: [
    IonicModule,
    TranslateModule.forChild()
  ],
  exports: [ SupplierSelectorComponent, SuppliersListComponent ],
  entryComponents: [ ]
})
export class SupplierSelectorComponentModule {}



// WEBPACK FOOTER //
// ./src/modules/supplier-selector/supplier-selector.module.ts